export default __webpack_public_path__ + "static/media/connection-method.c9525e28.svg";